/** Minimal region shape accepted by the pause calculator (avoids heavy ProgramChain imports in tests). */
export interface PauseRegionInput {
  startDate: Date;
  endDate: Date;
  regionOfInterestType: string;
}

/** Region types considered as pauses for the percentage calculation. */
const PAUSE_REGION_TYPES = ["POWER_FAIL", "DRYING_PAUSE"];

/**
 * Calculates the total drying pause duration in minutes from time regions of interest.
 * Filters to DRYING_PAUSE and POWER_FAIL regions, clamps them to the chain's time window,
 * discards invalid (negative/zero-length) intervals, merges overlapping ones, and sums.
 */
export function calculatePausesDurationInMinutes(
  timeRegionsOfInterest: PauseRegionInput[],
  chainStartMs: number,
  chainEndMs: number
): number {
  const pauseRegions = timeRegionsOfInterest
    .filter((region) => PAUSE_REGION_TYPES.includes(region.regionOfInterestType))
    .map((region) => ({
      start: Math.max(region.startDate.getTime(), chainStartMs),
      end: Math.min(region.endDate.getTime(), chainEndMs),
    }))
    .filter((region) => region.end > region.start)
    .sort((a, b) => a.start - b.start);

  const merged: { start: number; end: number }[] = [];
  for (const region of pauseRegions) {
    const last = merged[merged.length - 1];
    if (last && region.start <= last.end) {
      last.end = Math.max(last.end, region.end);
    } else {
      merged.push({ start: region.start, end: region.end });
    }
  }

  let total = 0;
  for (const region of merged) {
    total += (region.end - region.start) / 60000;
  }
  return total;
}
